import {
  Button,
  CloseButton,
  Combobox,
  Group,
  Text,
  useCombobox,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { HarvestProofStatusIcon } from '../harvest-proof-status-icon/harvest-proof-status-icon';

import classes from './harvest-proof-status-filter.module.css';

import {
  HARVEST_PROOF_FORM_STATUSES,
  HarvestProofFormStatus,
} from '@harvest-proof/data-access';

interface HarvestProofStatusFilterProps {
  onChange: (value: HarvestProofFormStatus) => void;
  onClear: () => void;
  value?: HarvestProofFormStatus;
}

export function HarvestProofStatusFilter({
  onChange,
  onClear,
  value,
}: HarvestProofStatusFilterProps) {
  const { t } = useTranslation();
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const options = HARVEST_PROOF_FORM_STATUSES.map((status) => (
    <Combobox.Option key={status} value={status}>
      <Group justify="center">
        <HarvestProofStatusIcon status={status} variant="form" />
      </Group>
    </Combobox.Option>
  ));

  return (
    <Combobox
      onOptionSubmit={(selected) => {
        onChange(selected as HarvestProofFormStatus);
        combobox.closeDropdown();
      }}
      position="bottom-start"
      store={combobox}
    >
      <Combobox.Target>
        <Button
          className={classes.button}
          color="gray"
          fullWidth
          justify="space-between"
          onClick={() => combobox.toggleDropdown()}
          px="sm"
          rightSection={
            value ? (
              <CloseButton
                aria-label={t('common.clear')}
                onClick={(event) => {
                  event.stopPropagation();
                  onClear();
                }}
                onMouseDown={(event) => event.preventDefault()}
                size="sm"
              />
            ) : (
              <Combobox.Chevron />
            )
          }
          tt="initial"
          variant="light"
        >
          {value ? (
            <HarvestProofStatusIcon status={value} variant="form" />
          ) : (
            <Text c="var(--mantine-color-placeholder)">
              {t('table.columns.status-filter-placeholder')}
            </Text>
          )}
        </Button>
      </Combobox.Target>
      <Combobox.Dropdown>
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
